'use client';

import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

export type FaqItem = { question: string; answer: string };

const STORE_FAQS: FaqItem[] = [
    {
        question: 'How do I earn Kick Points?',
        answer: 'You can earn Kick Points by watching live streams on Kick, joining special events, or participating in giveaways. The more you engage, the more Kick Points you collect for Store rewards.',
    },
    {
        question: 'Are prizes free to claim?',
        answer: 'Yes! All items available in the Store are sponsored rewards. They do not require real money to claim — only your earned Kick Points.',
    },
    {
        question: 'Can I have multiple accounts?',
        answer: 'No. Each user is allowed only one account tied to their real personal data. Creating multiple accounts will lead to suspension and forfeiture of all Store rewards.',
    },
    {
        question: 'How long does it take to receive a prize?',
        answer: 'After your prize is approved, delivery or digital access usually takes up to 14 business days. Some delays may occur depending on availability or your location.',
    },
    {
        question: 'Are real money payments accepted here?',
        answer: 'No. We does not accept or facilitate any monetary transactions. All rewards and promotions are free and supported by partner campaigns.',
    },
];

type Props = { id?: string; faqs?: FaqItem[] };

export default function FAQSection({ id = 'faq', faqs = STORE_FAQS }: Props) {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const toggleFAQ = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="mx-auto mt-20 mb-16 scroll-mt-32" id={id}>
            <h2 className="text-center text-4xl font-mono font-bold tracking-wider mb-10">
                <span className="bg-gradient-to-r from-green-400 via-emerald-300 to-green-500 bg-clip-text text-transparent">
                    <span className="text-green-300 inline-block animate-pulse">{'['}</span> FAQ  <span className="text-green-300 inline-block animate-pulse">{']'}</span>
                </span>
            </h2>

            <div className="space-y-4">
                {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className="backdrop-blur border-b border-green-400/30 rounded-xl p-5 hover:shadow-emerald-500/20 transition-all duration-300"
                    >
                        <button
                            onClick={() => toggleFAQ(index)}
                            className="w-full flex justify-between items-center text-left focus:outline-none"
                        >
                            <span className="text-gray-200 uppercase font-semibold text-[17px]">{faq.question}</span>
                            {openIndex === index ? (
                                <ChevronUp className="text-green-400" size={20} />
                            ) : (
                                <ChevronDown className="text-green-400" size={20} />
                            )}
                        </button>

                        <div
                            className={`overflow-hidden transition-all duration-200 ${openIndex === index ? 'max-h-60 mt-3 opacity-100' : 'max-h-0 opacity-0'
                                }`}
                        >
                            <p className="border-t-1 pt-2 border-gray-200/5 text-gray-200 text-sm leading-relaxed">
                                {faq.answer}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
